import { Caract_anteproy_loteo } from './../../../models/caract_anteproy_loteo.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-caract_anteproy_loteo",
    templateUrl: "./caract_anteproy_loteo.component.html",
    styleUrls:['./caract_anteproy_loteo.component.css'],
    providers: [FormService]
})

export class Caract_anteproy_loteoComponent {
    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public actualRow2;
      public caract_anteproy_loteo: Caract_anteproy_loteo;
      public form;
      public temp_carct_loteo;
      public matcher = new FormService();
      public nombreForm;

    constructor(private dialog: MatDialog){


        this.nombreForm = localStorage.getItem("form");
        console.log(this.nombreForm)
        this.form = new FormGroup({
            caract_anteproy_loteo: new FormControl(''),
            sup_ant_loteo: new FormControl(''),
            num_anteproy_act: new FormControl(''),
            sup_anteproy_act: new FormControl(''),
            hoja_anexa_loteo: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("caract_anteproy_loteo"))){
            localStorage.setItem("caract_anteproy_loteo", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("caract_anteproy_loteo"));
            
            this.form.controls['sup_ant_loteo'].setValue(this.rows[0]?this.rows[0].sup_ant_loteo:'')
            this.form.controls['num_anteproy_act'].setValue(this.rows[0]?this.rows[0].num_anteproy_act:'')
            this.form.controls['sup_anteproy_act'].setValue(this.rows[0]?this.rows[0].sup_anteproy_act:'')
            this.form.controls['hoja_anexa_loteo'].setValue(this.rows[0]?this.rows[0].hoja_anexa_loteo:'')

        }
        this.caract_anteproy_loteo = {sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''};
        this.temp_carct_loteo = {sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''};  
    }

    add_caract_anteproy_loteo(){
        

        this.actualRow = localStorage.getItem("caract_anteproy_loteo");

        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            caract_anteproy_loteo: this.form.value.caract_anteproy_loteo,
            sup_ant_loteo: this.form.value.sup_ant_loteo,
            num_anteproy_act: this.form.value.num_anteproy_act,
            sup_anteproy_act: this.form.value.sup_anteproy_act,
            hoja_anexa_loteo: this.form.value.hoja_anexa_loteo,
            total_sup_loteo: this.form.value.total_sup_loteo,
            total_num_loteo: this.form.value.total_num_loteo,
            numeroForms: 0,
            totalsup: 0
            
        })
        localStorage.setItem("caract_anteproy_loteo", JSON.stringify(this.rows));
        this.actualRow2 = localStorage.getItem("caract_anteproy_loteo");
        console.log(this.actualRow2)
      
        //this.form.reset();
    }

    get_caract_anteproy_loteo(id){
        console.log(id)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
               this.temp_carct_loteo.id = id;
               this.temp_carct_loteo.caract_anteproy_loteo =  this.rows[x].caract_anteproy_loteo;
               this.temp_carct_loteo.sup_ant_loteo =  this.rows[x].sup_ant_loteo;
               this.temp_carct_loteo.num_anteproy_act =  this.rows[x].num_anteproy_act;
               this.temp_carct_loteo.sup_anteproy_act =  this.rows[x].sup_anteproy_act;
               this.temp_carct_loteo.hoja_anexa_loteo =  this.rows[x].hoja_anexa_loteo;

               this.dialog.open(this.openModal);
            }
        }
    }

    cleanData(){
        this.temp_carct_loteo = {sup_ant_loteo:"",num_anteproy_act:"",sup_anteproy_act:"",hoja_anexa_loteo:""};
    }

    savecaract_anteproy_loteo(){
       var  id = this.temp_carct_loteo.id;
        console.log(this.temp_carct_loteo)
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify(this.rows));
           
                    $("#clasif_modal").modal("hide");
                    this.actualRow = localStorage.getItem("caract_anteproy_loteo");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        sup_ant_loteo: this.temp_carct_loteo.sup_ant_loteo,
                        num_anteproy_act: this.temp_carct_loteo.num_anteproy_act,
                        sup_anteproy_act: this.temp_carct_loteo.sup_anteproy_act,
                        hoja_anexa_loteo: this.temp_carct_loteo.hoja_anexa_loteo

                    })
                    localStorage.setItem("caract_anteproy_loteo", JSON.stringify(this.rows));
                    this.temp_carct_loteo = {sup_ant_loteo:"",num_anteproy_act:"",sup_anteproy_act:"",hoja_anexa_loteo:""};
                    this.dialog.closeAll();
                }
            }         
    }

    delete_caract_anteproy_loteo(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify(this.rows));
            }
        }
    }

}